
export default {
    nodekpis: {},
    nodekpivalues: {}
}
